"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Localization = void 0;
var _i18n = require("@ori/i18n");
var _jsxRuntime = require("react/jsx-runtime");
const Localization = props => {
  const {
    id,
    defaultMessage,
    values
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    "data-key": id,
    className: "translate",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
      id: id,
      defaultMessage: defaultMessage,
      values: values
    }, id)
  });
};
exports.Localization = Localization;
